import { render } from "./Eadge.vue?vue&type=template&id=42db57b2"
import script from "./Eadge.vue?vue&type=script&lang=js"
export * from "./Eadge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Eadge.vue"]])

export default __exports__